import axios from 'axios'

export default class Main {
  store = null
  router = null

  constructor (store, router) {
    this.store = store
    this.router = router
  }

  enforceAuthentication () {
    // console.log('Handle protected pages in main.js')
    let inRoute = false
    this.router.beforeEach((to, from, next) => {
      inRoute = true
      // console.log('Got router path ' + to.path)
      if (to.path.startsWith('/public')) {
        // console.log('Got a public page')
        next()
      } else if (to.path.startsWith('/task/')) {
        // console.log('Got a task page')
        next()
      } else if (to.path === '/login') {
        // console.log('Got the login page')
        next()
      } else {
        // console.log('Got a request for a protected page \'' + to.path + '\'')
        if (this.store.state.session.token) {
          // console.log('Access to protected page is granted as a session token is found: ' + this.store.state.session.token)
          next()
        } else {
          // console.log('No session token found, go to login page')
          next('/login')
        }
      }
    })
    if (!inRoute) {
      let path = window.location.pathname
      if (!this.store.state.session.token && !path.startsWith('/public') && !path.startsWith('/task/')) {
        // Check the session token in local storage
        let token = localStorage.getItem('SessionToken')
        if (token && token !== 'undefined' && token.length >= 0) {
          this.store.dispatch('session/tokenLogin', { token: token })
            .then(() => {
              this.store.dispatch('page/setSidebarItem', { key: 'dashboard' })
              this.router.push({ name: 'Dashboard' })
            })
            .catch(() => {
              console.log('Failed to login with token, will redirect to login page')
              this.router.push({name: 'Login'})
            })
        } else {
          // console.log('Not in route and not session token found, will redirect to login page')
          this.router.push({name: 'Login'})
        }
      }
    }
  }

  checkSession () {
    let online = navigator.onLine
    let store = this.store
    let router = this.router
    if (store.state.session.token !== '' && online) {
      axios.get('/backend/ui/session/status')
        .then(response => {
        })
        .catch(error => {
          if (store.state.session.token !== '' && error.response.status === 401) {
            store.dispatch('session/clear')
            store.dispatch('page/setSidebarItem', {})
            router.push({ name: 'Login' })
          }
        })
    }
  }

  startSessionChecker () {
    console.log('Starting session checker')
    let instance = this
    setTimeout(function () {
      instance.checkSession()
    }, 5000)
    setInterval(function () {
      instance.checkSession()
    }, 60000)
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascript/main.js